<template>
  <app-logged id="VisitasCreate">
    <v-flex xs12>
      <validation-observer
        ref="observer"
        v-slot="{ invalid }"
        tag="form"
      >
        <v-form>
          <app-widget
            actions
            class-widget="md6 offset-md3 sm8 offset-sm2 xs12"
          >
            <div slot="widget-content">
              <AppFormHeader
                title="Responsáveis"
                icon="supervisor_account"
              />
              <validation-provider
                name="técnico principal"
                rules="required"
                v-slot="{ errors }"
              >
                <v-autocomplete
                  clearable
                  :disabled="!!tecnico"
                  @click:clear="limparReferenciaDeTecnico"
                  :items="tecnicos"
                  v-model="visita.tecnico_id"
                  label="Técnico principal"
                  :return-object="false"
                  item-text="nome"
                  item-value="id"
                  :error-messages="errors[0]"
                />
              </validation-provider>
              <validation-provider
                name="técnico complementar"
                v-slot="{ errors }"
              >
                <v-autocomplete
                  clearable
                  @click:clear="limparReferenciaDeTecnico"
                  :items="tecnicos"
                  v-model="visita.tecnico_2_id"
                  label="Técnico complementar"
                  :return-object="false"
                  item-text="nome"
                  item-value="id"
                  :error-messages="errors[0]"
                />
              </validation-provider>
              <validation-provider
                name="Proporção de visita"
                rules="required"
                v-slot="{ errors }"
              >
                <v-select
                  :items="proporcoes"
                  v-model="visita.proporcao"
                  label="Proporção de visita"
                  :error-messages="errors[0]"
                />
              </validation-provider>
              <v-checkbox
                v-if="!!!visita.balancete"
                class="mt-0"
                v-model="visita.balancete_nao_requerido"
                label="Dispensado upload de balancete"
              />
              <AppFormHeader
                title="Detalhes"
                icon="feed"
              />
              <validation-provider
                name="cliente"
                rules="required"
                v-slot="{ errors }"
              >
                <v-autocomplete
                  clearable
                  @click:clear="limparReferenciaDeCliente"
                  :items="clientes"
                  v-model="visita.cliente_id"
                  label="Cliente responsável"
                  :return-object="false"
                  item-text="nome"
                  :item-disabled="(item) => !item.ativo"
                  item-value="id"
                  :error-messages="errors[0]"
                />
              </validation-provider>
              <validation-provider
                name="data da visita"
                rules="required"
                v-slot="{ errors }"
              >
                <v-text-field
                  type="date"
                  v-model="visita.data_visita"
                  label="Data de visita"
                  autocomplete="off"
                  :error-messages="errors[0]"
                />
              </validation-provider>
            </div>
            <div slot="widget-actions">
              <v-spacer />
              <app-button
                v-if="visita.id"
                @click.native="remove"
                color="error"
                class="mr-2"
              >
                remover
              </app-button>
              <app-button
                @click.native.prevent="save()"
                :disable="invalid"
              >
                salvar
              </app-button>
            </div>
          </app-widget>
        </v-form>
      </validation-observer>
    </v-flex>
  </app-logged>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import AppFormHeader from '@/components/AppFormHeader'
import AppLogged from '@/components/layouts/AppLogged'
import AppWidget from '@/components/AppWidget'
import AppButton from '@/components/AppButton'
export default {
  name: 'VisitasCreate',
  components: {
    AppWidget,
    AppLogged,
    ValidationProvider,
    ValidationObserver,
    AppFormHeader,
    AppButton
  },
  data () {
    return {
      tecnico: null,
      proporcoes: [
        '0.5', '1', '2'
      ]
    }
  },
  computed: {
    ...mapGetters(['visita', 'clientes', 'tecnicos'])
  },
  methods: {
    ...mapActions(['postSaveVisita', 'getUserAtual']),
    goToVisitaIndex () {
      return this.$router.push({
        name: 'visitas-index'
      })
    },
    goToVisitaDetails (id) {
      return this.$router.push({
        name: 'visitas-details',
        params: {
          id
        }
      })
    },
    limparReferenciaDeCliente () {
      delete this.visita.cliente_id
    },
    limparReferenciaDeTecnico () {
      delete this.visita.tecnico_id
    },
    async save () {
      this.$refs.observer.validate().then(async result => {
        if (result) {
          await this.postSaveVisita().then(({ data }) => {
            if (data.id) {
              return this.goToVisitaDetails(data.id)
            }
            return this.goToVisitaIndex()
          })
        }
      })
    }
  },
  async mounted () {
    const user = await this.getUserAtual()
    if (user.tecnico) {
      this.tecnico = user.tecnico.id
      this.visita.tecnico_id = user.tecnico.id
    }
  }
}
</script>
